import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link,  } from "react-router-dom";
import { Col } from "react-bootstrap";
import ShowSkeleton from "../utils/helpers/skeleton";
import {getAcademics,editAcademics} from "../store/slices/mpd";
import { GrUploadOption } from "react-icons/gr";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";

const Academics = () => {
  const user = JSON.parse(localStorage.getItem("users"));

  const token = user?.data?.accessToken;
  const [isloading, setisLoading] = useState(false);
  const dispatch = useDispatch();

const [formData, setFormData] = useState({
  feestructure: "",
  calendar: "",
  smc: "",
  pta: "",
});

const getInfo = () => {
  dispatch(getAcademics())
    .unwrap()
    .then((response) => {
      setFormData(response?.data || {});
    })
    .catch(({ message }) => console.error(message))
    .finally(() => {
      setisLoading(false);
    });
};

useEffect(() => {
  dispatch(getAcademics())
    .unwrap()
    .then((response) => {
      setFormData(response.data);
    });
}, []);

const uploadFile = async (e, fieldName) => {
  const file = e.target.files[0];

  if (!file) return;

  const allowedTypes = ["application/pdf"];

  if (!allowedTypes.includes(file.type)) {
    alert("Only PDF files are allowed");
    return;
  }

  if (file.size > 10 * 1024 * 1024) {
    alert("File size must be less than 10 MB");
    return;
  }

  try {
    const fileData = new FormData();
    fileData.append("file", file);

    const response = await fetch(
      `${API_BASE_URL}${API_PATHS.upload}`,
      {
        method: "POST",
        headers: {
          "x-access-token": token,
        },
        body: fileData,
      }
    );

    const data = await response.json();

    if (data?.status === 1 && data?.data?.location) {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: data.data.location,
      }));
    } else {
      alert("Upload failed");
    }
  } catch (error) {
    console.log(error);
    alert("Something went wrong");
  }
};



const handleSubmit = (e) => {
  e.preventDefault();

  dispatch(editAcademics(formData))
    .unwrap()
    .then(() => {
      alert("Academics Information Updated");
      getInfo();
    })
    .catch((err) => {
      alert(err.message);
    });
};

  return (
    <>
     
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Academics</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Academics</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
         
        </div>
      <div className="card-body px-24 py-24">
  {isloading ? (
    <Col lg={12} xs={12} md={12} align="center">
      {ShowSkeleton()}
    </Col>
  ) : (
    <form onSubmit={handleSubmit}>
      <div className="row">
       <div className="col-md-6 mb-20">
  <label className="form-label">
    Fee Structure PDF
  </label>

  <br />

  <label
    htmlFor="feestructureFile"
    className="btn btn-primary p-2"
  >
    <GrUploadOption />
    &nbsp; Upload 
  </label>

  <input
    type="file"
    id="feestructureFile"
    hidden
    accept=".pdf"
    onChange={(e) => uploadFile(e, "feestructure")}
  />

  {formData.feestructure && (
    <div className="mt-2">
      <a
        href={formData.feestructure}
        target="_blank"
        rel="noreferrer"
       
      >
        View Uploaded PDF
      </a>
    </div>
  )}
</div>

 <div className="col-md-6 mb-20">
  <label className="form-label">
    Calendar 
  </label>
  <br/>
 <label
  htmlFor="calendarFile"
  className="btn btn-primary p-2"
>
  <GrUploadOption />
  &nbsp; Upload
</label>

<input
  type="file"
  id="calendarFile"
  hidden
  accept=".pdf"
  onChange={(e) => uploadFile(e, "calendar")}
/>

  {formData.calendar && (
    <a className="mt-2 d-block"
      href={formData.calendar}
      target="_blank"
      rel="noreferrer"
    >
      View Uploaded PDF
    </a>
  )}
</div>

       <div className="col-md-6 mb-20">
  <label className="form-label">
    SMC PDF
  </label>
<br/>
  <label
  htmlFor="smcFile"
  className="btn btn-primary p-2"
>
  <GrUploadOption />
  &nbsp; Upload
</label>

<input
  type="file"
  id="smcFile"
  hidden
  accept=".pdf"
  onChange={(e) => uploadFile(e, "smc")}
/>
  {formData.smc && (
    <a className="mt-2 d-block"
      href={formData.smc}
      target="_blank"
      rel="noreferrer"
    >
      View Uploaded PDF
    </a>
  )}
</div>

  <div className="col-md-6 mb-20">
  <label className="form-label">
    PTA PDF
  </label>
  <br/>
  <label
  htmlFor="ptaFile"
  className="btn btn-primary p-2"
>
  <GrUploadOption />
  &nbsp; Upload
</label>

<input
  type="file"
  id="ptaFile"
  hidden
  accept=".pdf"
  onChange={(e) => uploadFile(e, "pta")}
/>

  {formData.pta && (
    <a className="mt-2 d-block"
      href={formData.pta}
      target="_blank"
      rel="noreferrer"
    >
      View Uploaded PDF
    </a>
  )}
</div>

       

        <div className="col-12 mt-3" align="center">
          <button
            type="submit"
            className="btn btn-primary px-5 py-2"
          >
           Update
          </button>
        </div>
      </div>
    </form>
  )}
</div>
      </div>
    </>
  );
};

export default Academics;
